// extracted by mini-css-extract-plugin
module.exports = {"dropDownAction":"TableDropdown_dropDownAction_2tTqG","spinAround":"TableDropdown_spinAround_ahLz6"};